'use client';
import Whisper from "./Whisper.js";
export default Whisper;